/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { SingleDetectorConnectorType } from './SingleDetectorConnectorType';
import {
    instanceOfSingleDetectorConnectorType,
    SingleDetectorConnectorTypeFromJSON,
    SingleDetectorConnectorTypeFromJSONTyped,
    SingleDetectorConnectorTypeToJSON,
} from './SingleDetectorConnectorType';

/**
 * @type CreateOtherQaEquipmentDtoSingleDetectorConnectorType
 * 
 * @export
 */
export type CreateOtherQaEquipmentDtoSingleDetectorConnectorType = SingleDetectorConnectorType;


export function CreateOtherQaEquipmentDtoSingleDetectorConnectorTypeFromJSON(json: any): CreateOtherQaEquipmentDtoSingleDetectorConnectorType {
    return CreateOtherQaEquipmentDtoSingleDetectorConnectorTypeFromJSONTyped(json, false);
}

export function CreateOtherQaEquipmentDtoSingleDetectorConnectorTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateOtherQaEquipmentDtoSingleDetectorConnectorType {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    // This is the original code, had to remove spread operator for const object enums that are not spreadable
    // return { ...SingleDetectorConnectorTypeFromJSONTyped(json, true) };
    return  SingleDetectorConnectorTypeFromJSONTyped(json, true);
}

export function CreateOtherQaEquipmentDtoSingleDetectorConnectorTypeToJSON(value?: CreateOtherQaEquipmentDtoSingleDetectorConnectorType | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }

    if (instanceOfSingleDetectorConnectorType(value)) {
        return SingleDetectorConnectorTypeToJSON(value as SingleDetectorConnectorType);
    }

    return {};
}

/**
 * Check if a given object implements the CreateOtherQaEquipmentDtoSingleDetectorConnectorType interface.
 */
export function instanceOfCreateOtherQaEquipmentDtoSingleDetectorConnectorType(value: any): value is CreateOtherQaEquipmentDtoSingleDetectorConnectorType {
    if (instanceOfSingleDetectorConnectorType(value)) return true;
    return false;
}

